import type { DirectiveBinding } from "vue";

function createRipple(event: MouseEvent, el: HTMLElement, color: string) {
    const rect = el.getBoundingClientRect();
    const ripple = document.createElement("span");

    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;

    ripple.style.position = "absolute";
    ripple.style.borderRadius = "50%";
    ripple.style.pointerEvents = "none";
    ripple.style.width = ripple.style.height = size + "px";
    ripple.style.left = x + "px";
    ripple.style.top = y + "px";
    ripple.style.backgroundColor = color;
    ripple.style.transform = "scale(0)";
    ripple.style.opacity = "0.75";
    ripple.style.transition = "transform 0.4s ease, opacity 0.6s ease";

    const container = el.querySelector(".ripple-container") as HTMLElement;
    if (!container) return;

    container.appendChild(ripple);

    requestAnimationFrame(() => {
        ripple.style.transform = "scale(2)";
        ripple.style.opacity = "0";
    });

    ripple.addEventListener("transitionend", () => ripple.remove());
}

const RippleDirective = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        let container = document.createElement("div");
        container.className = "ripple-container";
        container.style.position = "absolute";
        container.style.top = "0";
        container.style.left = "0";
        container.style.right = "0";
        container.style.bottom = "0";
        container.style.overflow = "hidden";
        container.style.borderRadius = "inherit";
        container.style.zIndex = "0"; 

        el.style.position = "relative";
        el.prepend(container);

        const color = binding.value || "rgba(0,0,0,0.3)";
        el.addEventListener("click", (e) =>
            createRipple(e as MouseEvent, el, color)
        );
    },
    unmounted(el: HTMLElement) {
        el.replaceWith(el.cloneNode(true)); // убираем слушатели при уничтожении
    },
};

export default RippleDirective;
